import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Verification.css";
import mailIcon from "../images/vector-10.svg";
import phoneIcon from "../images/vector-11.svg";
import arrowIcon from "../images/vector-12.svg";
import closeIcon from "../images/vector-14.svg";
import PopupMessage from "../PopupMessage/PopupMessage";
import { adminSendOtp } from "../Apis/AdminApis";

const Verification = ({ onClose }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
  const email = sessionStorage.getItem("adminEmail");
const handleSelect = async (type) => {
  if (!email) {
    setPopupMessage("Email not found. Please login again.");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  setLoading(true);

  const payload = {
    action: "login_otp",   
    email: email,
    otp_send_type: type,
  };

  const response = await adminSendOtp(payload);
  setLoading(false);

  if (response.error) {
    setPopupMessage(response.error);
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  setPopupMessage(response.message);
  setPopupType("success");
  setPopupOpen(true);

  sessionStorage.setItem("otpSendType", response.otp_send_type);
  sessionStorage.setItem("adminEmail", response.email);
  sessionStorage.setItem("adminRole", response.role);

  setTimeout(() => {
    onClose();
    navigate("/verify-otp");
  }, 800);
};

  return (
    <div className="verification-overlay">
      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />

      <div className="verification-card">
        <div className="verification-header">
          <h2 className="verification-title">Verification</h2>
          <img
            src={closeIcon}
            alt="close"
            className="close-icon"
            onClick={onClose}
          />
        </div>

        <p className="verification-subtitle">
          Choose how you'd like to verify your profile
        </p>

        <div className="verification-options">
          <div
            className="verification-option"
            onClick={() => handleSelect("email")}
          >
            <div className="option-left">
              <div className="icon-container">
                <img src={mailIcon} className="option-icon" alt="Email" />
              </div>
              <div className="option-text">
                <h3>Email</h3>
                <p>We'll send a verification code to your email address.</p>
              </div>
            </div>
            <img src={arrowIcon} className="option-arrow" alt="arrow" />
          </div>

          <div
            className="verification-option"
            onClick={() => handleSelect("mobile")}
          >
            <div className="option-left">
              <div className="icon-container">
                <img src={phoneIcon} className="option-icon" alt="Phone" />
              </div>
              <div className="option-text">
                <h3>Phone</h3>
                <p>We'll send an SMS with a verification code to your phone.</p>
              </div>
            </div>
            <img src={arrowIcon} className="option-arrow" alt="arrow" />
          </div>
        </div>

        {loading && <p style={{ textAlign: "center" }}>Sending OTP...</p>}
      </div>
    </div>
  );
};

export default Verification;
